import { useEffect, useState } from 'react';

const STORAGE_KEY = 'porkysbbq:darkMode';

const apply = (enabled: boolean) => {
    if (enabled) document.body.classList.add('dark-mode');
    else document.body.classList.remove('dark-mode');
};

const DarkModeToggle = ({ style }: { style?: React.CSSProperties }) => {
    const [dark, setDark] = useState<boolean>(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === 'true';
        } catch {
            return false;
        }
    });

    useEffect(() => {
        apply(dark);
        try {
            localStorage.setItem(STORAGE_KEY, String(dark));
        } catch {
            /* ignore */
        }
    }, [dark]);

    return (
        <button
            onClick={() => setDark((d) => !d)}
            style={{
                background: dark ? '#2a2a2a' : '#f0eeee',
                color: dark ? '#f0eeee' : '#373737',
                border: '0.15rem solid #888',
                borderRadius: '999px',
                padding: '0.5rem 1rem',
                fontSize: '1.4rem',
                fontWeight: 700,
                cursor: 'pointer',
                ...style,
            }}
            aria-label="Toggle dark mode"
        >
            {dark ? '☀ Light' : '☾ Dark'}
        </button>
    );
};

export default DarkModeToggle;
